<template>
    <v-card
            class="mx-auto"
            :style="{width: editDialogWidth+'%',height:'fit-content'}"
    >
        <v-toolbar dark dense color="toolbar">
            <v-toolbar-title> 最新消息 </v-toolbar-title>

            <v-spacer></v-spacer>
            <v-btn v-show="this.isDialog==true" title="關閉視窗" icon dark @click.native="closeDialog">
                <v-icon>mdi-close</v-icon>
            </v-btn>

        </v-toolbar>

        <!-- :style="{overflow: $vuetify.breakpoint.smAndDown?'scroll':'auto'}"-->
        <v-carousel
                :height="this.isDialog==true?'auto':'auto'"
                style="overflow: scroll"
                :show-arrows="true"
                cycle
        >
            <v-carousel-item
                    v-for="(item, index) in newsList"
                    :key="index"
            >
                    <v-row
                            class="fill-height row--dense row wrap"
                            align="center"
                            justify="center"
                    >
                        <v-flex xs12 sm12 md6 lg6 v-if="item.mainPict">
                            <img v-show="item.mainPict!==undefined" :src="item.mainPict" style="width: auto;max-width: 100%;" />
                        </v-flex>

                        <v-flex xs12 sm12 md6 lg6 v-if="item.content">
                            <div v-html="item.content" class="black--text px-2 py-2" style="white-space: pre-line;overflow: auto;height: 70vh">
                                {{ item.content }}
                            </div>
                        </v-flex>

                    </v-row>

            </v-carousel-item>
        </v-carousel>
    </v-card>
</template>

<script>
    export default {
        name: "NewsSlide",
        data() {
            return {
                newsList: [],
            }
        },
        props:{
            isDialog:{
                type:Boolean,
                default:false
            }
        },
        created(){
            let today = this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(),'showDT');
            this.axios_getEffNews(today);//取得有效公告訊息 1101004
        },
        computed:{
            editDialogWidth(){ //隨畫面大小 調整Dialog的寬度
                let width = 60;
                if (this.$vuetify.breakpoint.xs == true) {width = 100 }
                if(this.$vuetify.breakpoint.sm == true){width = 97}
                if(this.$vuetify.breakpoint.md == true){width =  80}
                if(this.$vuetify.breakpoint.lg == true){width =  70}
                if(this.$vuetify.breakpoint.xl ==true){width =  60}
                return width
            },
        },
        methods:{
            closeDialog(){
                this.$emit('closeDialog');
            },
            axios_getEffNews (date){ //查詢有效訊息公告 110/10/04
                this.newsList = [];
                let start = date.replace(new RegExp("-","gm"),"");
                let sDateTime =  start.split(" ");
                let sTime = sDateTime[1].replace(new RegExp(":","gm"),"");

                let url = '';
                url = this.$store.state.AppSetting.backSrvUrl + "news/datasearch/effectivemenu/"+sDateTime[0]+""+sTime;

                this.$http.get(url).then(response =>{
                    if(response.data.status == 'INFO' && response.data.hasOwnProperty('resultSet') && response.data.resultSet.length>0){
                        this.newsList = response.data.resultSet;

                    }else{
                        this.newsList = [];
                    }

                }).catch(error =>  {
                    try {
                        console.log(error.response.data.status);
                        this.newsList = [];
                    } catch(err) {
                        this.newsList = [];
                    }

                });
            },
        }
    }
</script>

<style scoped>

</style>